import { get } from "lodash";

export const getValue = (obj, key, defaultVal) => get(obj, key, defaultVal);
